module.exports = __webpack_public_path__ + "static/media/photo-10.21ede388.png";